export default __webpack_public_path__ + "static/media/ic_google.f1271a99.svg";